import './App.css';
import { useState, useMemo, useCallback, useEffect } from "react";
import AccountRemoval from './Components/AccountRemoval';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ResearchContext } from './Components/ResearchContext';
import { BACKEND_URL, CLIENT_AUTH_SECRET, GOOGLE_LOGIN_CLIENT_ID } from './secrets';
import Cookies from 'universal-cookie';
import { SocialLogin } from '@capgo/capacitor-social-login';

const cookies = new Cookies();

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

useEffect(() => {
    SocialLogin.initialize({
      google: {
        webClientId: GOOGLE_LOGIN_CLIENT_ID
      }
    });
}, []);

  const checkForExistingUser = useCallback(async () => {
    if (cookies.get('user')) {
      let tempUser = {};
      
      await fetch(BACKEND_URL + "/get_user_by_id?id=" + cookies.get('user').replace('id_', ''), {
          method: 'GET',
          headers: {
            'Authorization': `Bearer: ${CLIENT_AUTH_SECRET}`,
            'Content-Type': 'application/json;charset=utf-8'
          },
          mode: 'cors'
      }).then(response => {
        if(!response.ok) {
          throw new Error('Getting user with cookie ID failed');
        }
        return response.json();
      }).then(data => {
        tempUser.id = data[0].id;
        tempUser.username = data[0].username;
        tempUser.permLevel = data[0].permissions;
        tempUser.dateJoined = data[0].dateJoined;
        tempUser.lastLogin = data[0].lastLoginDay;
        setCurrentUser(tempUser);
        setIsLoggedIn(true);
      }).catch(error => {
        console.error('Error: ', error);
      });
    }
  }, []);

  const researchValue = useMemo(() => ({
    currentUser, 
    setCurrentUser, 
    isLoggedIn, 
    setIsLoggedIn, 
    cookies,
    checkForExistingUser
  }), [
    currentUser, 
    isLoggedIn, 
    checkForExistingUser
  ]);

  return (
    <div className="App">
      <BrowserRouter>
        <ResearchContext.Provider value={researchValue}>
          <AccountRemoval />
        </ResearchContext.Provider>
      </BrowserRouter>
    </div>
  );
}

export default App;